import { SVGProps, Ref, forwardRef } from 'react';

export const RabotaByBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M13.18 15H2.82A1.82 1.82 0 0 1 1 13.18V2.82A1.82 1.82 0 0 1 2.82 1h10.36A1.82 1.82 0 0 1 15 2.82v10.36A1.82 1.82 0 0 1 13.18 15"
            fill="#E80200"
        />
        <path
            d="M12.06 7.055A2.905 2.905 0 0 0 9.155 4.15H4.36v7.7h1.96V9.96h2.35l1.29 1.89h2.1l-1.53-2.235a2.92 2.92 0 0 0 1.53-2.56M9.155 8H6.32V6.11h2.835c.52 0 .945.425.945.945S9.675 8 9.155 8"
            fill="white"
        />
    </svg>
));
RabotaByBrandSize16Glyph.displayName = 'RabotaByBrandSize16Glyph';
